import { META } from 'constants/trackerKinds';

export const fbEntrancePopup = {
  title: `$t(tracker:displayKind, {"context": "${META}"})`,
  content:
    'メタピクセルは「Facebook Business Extension Package」のインストールが必要があります。インストールしますか?',
  content_edit:
    '「Facebook Business Extension」の「Edit Assets」をクリックして Facebook ピクセルを編集しますか?',
  content_remove:
    'Facebook Business Extension をアンインストールすると、Facebook ピクセルが削除されます。キャンセルしますか?',
  ok: 'インストールへ',
  ok_edit: '編集へ',
  ok_remove: 'キャンセルへ',
  cancel: '今はやめる',
};
